import { EtatAdministratif } from '@common/services';

export const ETAT_ADMINISTRATIF_TEXTS: Record<EtatAdministratif, string> = {
  [EtatAdministratif.ACTIF]: 'Actif',
  [EtatAdministratif.FERME]: 'Fermé',
};